import React, {
  ReactElement,
  useState,
  useMemo
} from 'react';
import Picker from './Picker';
import unSelected from '@assets/un-selected.png';
import selected from '@assets/selected.png';
import Toast from '@xpeng/rc-toast';
import './index.less';

interface Props {
  title: string;
  show: boolean;
  regionList: TArea[];
  selectedIndexs: number[];
  onCancel: () => void;
  onSure: (value: TArea[]) => void;
}
export interface TAreaAddress {
  regionCode?: string;
  regionName?: string;
  childList?: TAreaAddress[];
  isChecked?: boolean;
  center?: string;
}

export interface TArea {
  name?: string;
  adcode?: string;
  districts?: TArea[];
  isChecked?: boolean;
  center?: string;
}
export default function CityPicker(props: Props): ReactElement {
  const { title, show, regionList, onSure, onCancel } = props;
  //省下标
  const [provinceIndex, setProvinceIndex] = useState<number>(0);
  //市下标
  const [cityIndex, setCityIndex] = useState<number>(0);
  //区下标
  const [areaIndex, setAreaIndex] = useState<number>(0);
  // 当前选中的下标
  const [selectedIndex, setSelectedIndex] = useState<number>(0);

  const [area, setArea] = useState<TArea[]>([]);

  // 省数据
  const provinces = useMemo<TArea[]>(() => {
    return regionList ? regionList.map(a => a || '') : [];
  }, [regionList]);

  // 城市数据
  const cities = useMemo<TArea[]>(() => {
    if (!regionList || !regionList.length) {
      return [];
    }
    const province = regionList[provinceIndex];
    if (!province || !province.districts || !province.districts.length) {
      return [];
    }
    return province.districts.map(a => a || '');
  }, [regionList, provinceIndex]);

  // 区数据
  const areas = useMemo<TArea[]>(() => {
    if (!regionList || !regionList.length) {
      return [];
    }
    const province = regionList[provinceIndex];
    if (!province || !province.districts || !province.districts.length) {
      return [];
    }
    const city = province.districts[cityIndex];
    if (!city || !city.districts || !city.districts.length) {
      return [];
    }
    if (areaIndex > city.districts.length - 1) {
      setAreaIndex(0);
    }

    return city.districts.map(a => a || '');
  }, [regionList, cityIndex, provinceIndex]);

  const showList = useMemo<TArea[]>(() => {
    switch (selectedIndex) {
      case 0:
        return provinces;
      case 1:
        return cities;
      case 2:
        return areas;
      default:
        return provinces;
    }
  }, [selectedIndex, provinces, cities, areas]);

  const onAreaChange = (selectedIndex: number, index: number) => {
    if (selectedIndex === 0) {
      setProvinceIndex(index);
      provinces.map((item, provinceIndex) => {
        if (provinceIndex === index) {
          item.isChecked = true;
        } else {
          item.isChecked = false;
        }
      });
      cities.map(item => {
        item.isChecked = false;
      });
      areas.map(item => {
        item.isChecked = false;
      });
      let selectedProvince = provinces[index];
      setArea([selectedProvince]);
      setSelectedIndex(1);
    } else if (selectedIndex === 1) {
      setCityIndex(index);
      cities.map((item, cityIndex) => {
        if (cityIndex === index) {
          item.isChecked = true;
        } else {
          item.isChecked = false;
        }
      });
      areas.map(item => {
        item.isChecked = false;
      });
      let selectedCity = cities[index];
      area[1] = selectedCity;
      area[2] = {};
      const newAreaList = area;
      setArea([...newAreaList]);
      setSelectedIndex(2);
    } else if (selectedIndex === 2) {
      setAreaIndex(index);
      areas.map((item, areaIndex) => {
        if (areaIndex === index) {
          item.isChecked = true;
        } else {
          item.isChecked = false;
        }
      });
      let selectedArea = areas[index];
      area[2] = selectedArea;
      const newAreaList = area;
      setArea([...newAreaList]);
    }
  };

  const onConfirm = () => {
    if (area && area.length < 3) {
      Toast.show('请选择省市区');
      return;
    }
    onSure(area);
    onCancel();
  };

  return (
    <Picker
      title={title}
      show={show}
      onCancel={onCancel}
      onSure={onConfirm}
      render={() => (
        <div className="city-area">
          {!!area.length && (
            <div className="title">
              {!!area.length &&
                area.map((item, index) => {
                  return (
                    <div
                      className={`privince ${index === selectedIndex ? 'selected' : ''
                        }`}
                      onClick={() => {
                        setSelectedIndex(index);
                      }}
                      key={index}
                    >
                      {item.name}
                    </div>
                  );
                })}
            </div>
          )}
          <div
            className="area-list"
            onTouchMove={event => {
              event.stopPropagation();
            }}
          >
            {!!showList.length &&
              showList.map((item, index) => {
                return (
                  <div
                    key={item.adcode}
                    className="select-item"
                    onClick={() => onAreaChange(selectedIndex, index)}
                  >
                    <div>{item.name}</div>
                    <img
                      src={item.isChecked ? selected : unSelected}
                      className="img"
                      alt=""
                    />
                  </div>
                );
              })}
          </div>
        </div>
      )}
    />
  );
}
